import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import { CopyToClipboard } from 'react-copy-to-clipboard';

/**
 * 通用代码高亮和复制组件
 * @param {Object} props
 * @param {string} props.code - 要高亮的代码字符串
 * @param {string} props.language - 代码语言，如 'javascript', 'typescript', 'python', 'java', 'bash' 等
 * @param {Object} [props.style] - 可选的自定义样式
 * @param {Array} [props.languages] - 可用的语言选项数组，每项包含 value 和 label
 * @param {Function} [props.onLanguageChange] - 语言切换回调函数
 * @returns {JSX.Element}
 */
const CodeBlock = ({ 
    code, 
    language, 
    style = {},
    languages = null,
    onLanguageChange = null
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const showLanguageSelector = languages && onLanguageChange;

    return (
        <div className="relative">
            <SyntaxHighlighter
                language={language}
                style={vscDarkPlus}
                className="rounded-md"
                customStyle={{ 
                    paddingTop: '1.75rem', 
                    paddingBottom: '1rem', 
                    paddingLeft: '1rem', 
                    paddingRight: '1rem',
                    ...style 
                }}
            >
                {code}
            </SyntaxHighlighter>
            
            <div className="absolute top-0.5 right-2 flex space-x-2">
                {showLanguageSelector && (
                    <div className="relative inline-block">
                        <select
                            className="appearance-none bg-gray-700 text-white border border-gray-600 py-1 px-2 pr-6 rounded text-xs leading-tight focus:outline-none hover:bg-gray-600"
                            value={language === 'bash' ? 'curl' : language}
                            onChange={(e) => onLanguageChange(e.target.value)}
                        >
                            {languages.map((lang) => (
                                <option key={lang.value} value={lang.value}>
                                    {lang.label}
                                </option>
                            ))}
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 text-white">
                            <svg className="fill-current h-3 w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                            </svg>
                        </div>
                    </div>
                )}
                
                <CopyToClipboard text={code} onCopy={handleCopy}>
                    <button
                        className="bg-gray-700 hover:bg-gray-600 text-white px-2 py-1 rounded text-xs"
                        aria-label="复制代码"
                    >
                        {copied ? '已复制!' : '复制'}
                    </button>
                </CopyToClipboard>
            </div>
        </div>
    );
};

export default CodeBlock; 